import { SelectCardGroup, SelectCard } from "@gisce/oficina-virtual-components";

import { LoadingAnimation } from '../../../LoadingAnimation';
import { RichContent } from "@gisce/oficina-virtual-components";
import { FC } from "react";
import { Product } from "@/components/Contractation/types/products";
import { useTranslation } from "react-i18next";
import { Alert } from "@mui/material";
import { ControllerRenderProps } from "react-hook-form";
import { useSettingsContext } from "@/components/Settings/hooks/useSettingsContext";


interface IElectricityProductsSelectProps {
  loading: boolean;
  availableProducts: Product[];
  input: ControllerRenderProps;
}

const ElectricityProductSelect: FC<IElectricityProductsSelectProps> = ({
  loading,
  availableProducts,
  input
}) => {
  const Settings = useSettingsContext();
  const { t } = useTranslation();

  return loading ? (
    <LoadingAnimation />
  ) : (
    <>
      <SelectCardGroup 
        container 
        spacing={3}
        onChange={input.onChange}
        value={input.value}
      >
        {availableProducts.map(
          product => <SelectCard
            xs={12}
            md={6}
            key={product.id}
            value={product.id}
            name={product.name}
            description={product.ov_description}
            descriptionType="html"
            moreInformation={ product.ov_link ? {
              link: product.ov_link,
              label: "+ info"
            } : undefined}
          />
        )}
      </SelectCardGroup>
      { availableProducts.length === 0 && (
        <Alert severity="warning" sx={{mt: 3}}>
          <RichContent
            content={t('common:text.contractation_no_available_tariffs',
              {
                phone: "900 908 101",
                phoneLink: "900908101"
              }
            )}
          />         
        </Alert>
      )}
    </>
  );
}

export default ElectricityProductSelect;
